/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Pagamenti { 
    is_presente_ricarica_da_pagare?: boolean;
    giorni_residui_sospensione_servizio?: number;
    importo_residuo_prima_sospensione?: number;
}

